import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Paper,
  TextField,
  Toolbar,
  Typography,
  Divider,
  List,
  ListItemButton,
  Snackbar,
  Alert,
  ButtonGroup,
  CircularProgress,
  Stack,
  Chip,
} from "@mui/material";
import InputMask from "react-input-mask";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import AdminRecruiters from "./AdminRecruiters";
import Admindashboardinterviews from "../AdminCandidatePage/Admindashboardinterviews";
import { useDispatch, useSelector } from "react-redux";
import { appSelector } from "../../redux/selector";
import { userSelector } from "../../user-redux/selector";
import Nocandidatefound from "../../images/Nocandidate.png";
import {
  addOrEditRecruiterAction,
  getActiveCandidatesAction,
  getMyRecruitersAction,
  getcandidateSubmissionsAction,
  getMyInactiveRecruitersAction,
} from "../../redux/action";
import LoadingSkeleton from "../../loadingSkeletons/LoadingList";
import AllocatedCandidatesList from "./AllocatedCandidatesList";
import Adminrecruitersubmissions from "./AdminRecruitersubmissions";
import Adminselected from "../AdminCandidatePage/Adminselected";
import { CallMadeOutlined, CallReceivedOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router";

const Admin_Allocation = ({ }) => {
  const dispatch = useDispatch();
  const { myRecruiters, inactiveRecruiters, candidateSubmissions, jobDetails, isRecLoading } = useSelector(appSelector);
  const { user } = useSelector(userSelector);
  const [openRecruiterDialog, setOpenRecruiterDialog] = useState(false);
  const [recruiterFormData, setRecruiterFormData] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [addRecruiterLoading, setRecruiterLoading] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [nameError, setNameError] = useState(false); // Define state for name error
  const [noRecruiterFound, setNoRecruiterFound] = useState(false);
  const [loading, setLoading] = useState(true);
  const [activeCandidates, setActiveCandidates] = useState([]);
  const [linkedInUrlError, setLinkedInUrlError] = useState("");

  const [loadingRecruiters, setLoadingRecruiters] = useState(true); // Loader for fetching recruiters
  const [hasDataLoaded, setHasDataLoaded] = useState(false); // Track if data has been fetched at least once
  const [view, setView] = useState("default")
  const [selectedJobOrCompany, setSelectedJobOrCompany] = useState(null);
  const handleCompanyClick = (payload) => {
    //console.log("payload", payload)
    setSelectedJobOrCompany(payload || null);
    setView("job");
  };
  const [hasApiStarted, setHasApiStarted] = useState(false);

  // useEffect(() => {
  //   console.log("myRecruiters", myRecruiters)
  // }, [myRecruiters])

  // New State Variables for Search Functionality
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const handleIconClick = () => {
    setIsSearchActive(!isSearchActive);
    setSearchTerm("");
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  useEffect(() => {
    setRecruiterFormData({
      company_admin_id: user?.id,
      recruiter_name: "",
      recruiter_role: "Benchsales",
      recruiter_email: "",
      recruiter_linkedin: "",
      recruiter_phone: "",
      recruiter_password: "",
      recruiter_company_id: user?.companyid,
      status: 1,
      usertypeid: 3,
      action: "Add",
      recruiter_id: null,
      session_token: user.session_token,
      register_type: "CSR",
    });
  }, []);

  const handleAddRecruiter = () => {
    if (!user?.companyid) {
      handleSnackBar("Please add company details", "error");
    } else {
      setRecruiterFormData({
        company_admin_id: user?.id,
        recruiter_name: "",
        recruiter_role: "Benchsales",
        recruiter_email: "",
        recruiter_linkedin: "",
        recruiter_phone: "",
        recruiter_password: "",
        recruiter_company_id: user?.companyid,
        status: 1,
        usertypeid: 3,
        action: "Add",
        recruiter_id: null,
        session_token: user?.session_token,
        register_type: "CSR",
      });
      setOpenRecruiterDialog(true);
    }
  };

  const handleRecruiterDialogClose = () => {
    setOpenRecruiterDialog(false);
    setRecruiterFormData({
      company_admin_id: user?.id,
      recruiter_name: "",
      recruiter_role: "Benchsales",
      recruiter_email: "",
      recruiter_linkedin: "",
      recruiter_phone: "",
      recruiter_password: "",
      recruiter_company_id: user?.companyid,
      status: 1,
      usertypeid: 3,
      action: "Add",
      recruiter_id: null,
      session_token: user?.session_token,
      register_type: "CSR",
    });
  };

  const handleRecruiterChange = (e) => {
    const { name, value } = e.target;
    setRecruiterFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const validateEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const recruiterEmail = user?.username;
    const domain = recruiterEmail.split("@")[1];
    const enteredDomain = email.split("@")[1];

    if (!emailPattern.test(email) && domain != enteredDomain) {
      return "Invalid email format";
    }

    if (emailPattern.test(email) && domain != enteredDomain) {
      return "Email Domains Not Matching";
    }

    return ""; // No error
  };

  const handleRecruiterSubmit = async () => {

    let normalizedData = { ...recruiterFormData };

    normalizedData.recruiter_email = recruiterFormData.recruiter_email.trim().toLowerCase();
    normalizedData.recruiter_name = recruiterFormData.recruiter_name.trim();

    if (user?.companyid) {
      // Check if the Name field is empty
      if (!normalizedData.recruiter_name) {
        setNameError(true);
        handleSnackBar("Name is required.", "error");
        return;
      }

      if (user.username === normalizedData.recruiter_email) {
        setEmailError("This email is already registered.");
        handleSnackBar("This email is already registered.", "error");
        return;
      }


      // Email validation
      const emailError = validateEmail(normalizedData.recruiter_email);

      if (isEmailAlreadyRegistered(normalizedData.recruiter_email)) {
        setEmailError("This email is already registered.");
        handleSnackBar("This email is already registered.", "error");
        return;
      }
      if (inactiveRecruiterEmail(normalizedData.recruiter_email)) {
        setEmailError("This email is already registered.");
        handleSnackBar("This email is already registered.", "error");
        return;
      }

      if (emailError) {
        setEmailError(emailError);
        handleSnackBar(emailError, "error");
        return;
      }

      if (normalizedData.recruiter_linkedin) {
        const linkedinPattern = /^(https:\/\/)?(www\.)?linkedin\.com\/in\/[a-zA-Z0-9-_%]+\/?$/i;
        if (!linkedinPattern.test(normalizedData.recruiter_linkedin)) {
          setLinkedInUrlError("Invalid LinkedIn URL.");
          handleSnackBar("Invalid LinkedIn URL.", "error");
          return;
        }
      }

      setRecruiterLoading(true);

      let rec_data = {
        company_id: user?.companyid,
      };

      await dispatch(addOrEditRecruiterAction(normalizedData, rec_data));

      setRecruiterLoading(false);
      setOpenRecruiterDialog(false);
    } else {
      handleSnackBar("Please add company details", "error");
    }
  };

  const handleSnackBar = (message, severity) => {
    setSnackbarOpen(true);
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
  };

  useEffect(() => {
    if (!user?.companyid) {
      setLoadingRecruiters(false);
      return;
    }

    setLoadingRecruiters(true);

    const rec_data = { company_id: user.companyid };
    setHasApiStarted(true);
    dispatch(getMyRecruitersAction(rec_data));

  }, [user?.companyid]);

  // useEffect(() => {
  //   //console.log("isRecLoading", isRecLoading)
  // }, [isRecLoading])

  // Handle loading state and empty data dialog
  useEffect(() => {
    // Do NOT run dialog logic until API actually begins
    if (!hasApiStarted) return;

    // Only run AFTER loading finishes
    if (!isRecLoading) {
      if (Array.isArray(myRecruiters) && myRecruiters.length === 0) {
        setNoRecruiterFound(true);
      } else {
        setNoRecruiterFound(false);
      }
    }
  }, [hasApiStarted, isRecLoading, myRecruiters]);




  const isEmailAlreadyRegistered = (email) => {
    return myRecruiters?.some(
      (recruiter) => recruiter.recruiter_email === email
    );
  };

  const inactiveRecruiterEmail = (inactiveEmail) => {

    if (!Array.isArray(inactiveRecruiters)) {
      return false;
    }

    const found = inactiveRecruiters.some(
      (recruiter) => {
        return recruiter.recruiter_email === inactiveEmail;
      }
    );
    return found;
  };

  const handleCloseDialog = () => {
    setNoRecruiterFound(false);
    navigate("/admin-dashboard");
  };

  const handleGoToCompanySettings = () => {
    navigate("/admin-dashboard");
  };

  const handleCloseCompanyDialog = () => {
    navigate("/admin-dashboard");
  };

  const hasCompanyId = Boolean(user?.companyid);

  const htmlToPlainText = (html) => {
    if (!html) return "";
    try {
      const doc = new DOMParser().parseFromString(html, "text/html");
      return (doc.body && (doc.body.innerText || doc.body.textContent)) || "";
    } catch (e) {
      return html.replace(/<\/?[^>]+(>|$)/g, "");
    }
  };

  return (
    <Box sx={{ pt: 0.5, px: 0.5, mx: { xs: -1, md: -2 }, height: "calc(100vh - 65px)", display: "flex", flexDirection: "column", bgcolor: "#F8F8F8", position: "relative" }}>
      <Box sx={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
        {hasCompanyId && (
          <>
            <Box sx={{ pb: 0.5 }}>
              <Paper elevation={2}>
                <Toolbar
                  style={{ display: "flex", justifyContent: "space-between", minHeight: "42px" }}
                >
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleAddRecruiter}
                    style={{ backgroundColor: "#406882", textTransform: "none", boxShadow: "none", height: "30px" }}
                  >
                    Add Recruiter
                  </Button>
                </Toolbar>
              </Paper>
            </Box>

        <Grid container spacing={0.5} sx={{ flex: 1, minHeight: 0 }}>
          {/* Recruiter List*/}
          <Grid item xs={12} md={2.4} sx={{ height: "100%" }}>
            <Paper elevation={2} sx={{ height: "100%", display: "flex", flexDirection: "column", borderRadius: "8px", overflow: "hidden" }}>
              <Toolbar
                sx={{
                  minHeight: "42px !important",
                  pl: { sm: 2 },
                  pr: { xs: 1, sm: 1 },
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                {isSearchActive ? (
                  <TextField
                    value={searchTerm}
                    onChange={handleSearchChange}
                    placeholder="Search recruiter name"
                    variant="outlined"
                    size="small"
                    style={{ flex: 1 }}
                  />
                ) : (
                  <Typography variant="body1">Recruiters</Typography>
                )}
                {isSearchActive ? (
                  <CloseIcon
                    onClick={handleIconClick}
                    style={{
                      cursor: "pointer",
                      marginLeft: "10px",
                      color: "#696969",
                    }}
                  />
                ) : (
                  <SearchIcon
                    onClick={handleIconClick}
                    style={{
                      cursor: "pointer",
                      marginLeft: "10px",
                      color: "#696969",
                    }}
                  />
                )}
              </Toolbar>
              <Divider sx={{ margin: 0 }} />
              <Box sx={{ flex: 1, overflowY: "auto", minHeight: 0 }}>
                {isRecLoading ? (
                  <LoadingSkeleton />
                ) : (
                  <AdminRecruiters
                    recruiters={myRecruiters}
                    searchTerm={searchTerm}
                    onSearchChange={handleSearchChange}
                  />
                )}
              </Box>
            </Paper>
          </Grid>

          {/* Candidates */}
          <Grid item xs={12} md={2.4} sx={{ height: "100%" }}>
            <Paper elevation={2} sx={{ height: "100%", display: "flex", flexDirection: "column", borderRadius: "8px", overflow: "hidden" }}>
              <Toolbar
                sx={{
                  minHeight: "42px !important",
                  pl: { sm: 2 },
                  pr: { xs: 1, sm: 1 },
                }}
              >
                <Typography>Candidates</Typography>
              </Toolbar>
              <Divider sx={{ margin: 0 }} />
              <Box sx={{ flex: 1, overflowY: "auto", minHeight: 0 }}>
                {isRecLoading ? (
                  <LoadingSkeleton />
                ) : (
                  <AllocatedCandidatesList setActiveCandidates={setActiveCandidates} />
                )}
              </Box>
            </Paper>
          </Grid>

          {/* Submissions */}
          <Grid item xs={12} md={2.4} sx={{ height: "100%" }}>
            <Paper elevation={2} sx={{ height: "100%", display: "flex", flexDirection: "column", borderRadius: "8px", overflow: "hidden" }}>
              <Toolbar
                sx={{
                  minHeight: "42px !important",
                  pl: { sm: 2 },
                  pr: { xs: 1, sm: 1 },
                }}
              >
                <Typography>Submissions</Typography>
              </Toolbar>
              <Divider sx={{ margin: 0 }} />
              <Box sx={{ flex: 1, overflowY: "auto", minHeight: 0 }}>
                <Adminrecruitersubmissions activeCandidates={activeCandidates} handleCompanyClick={handleCompanyClick} handleCloseJobView={() => setView("default")} />
              </Box>
            </Paper>
          </Grid>

          {/* Interviews */}
          <Grid item xs={12} md={2.6} sx={{ height: "100%" }}>
            <Paper elevation={2} sx={{ height: "100%", display: "flex", flexDirection: "column", borderRadius: "8px", overflow: "hidden" }}>
              <Toolbar
                sx={{
                  minHeight: "42px !important",
                  pl: { sm: 2 },
                  pr: { xs: 1, sm: 1 },
                }}
              >
                <Typography>Interviews</Typography>
              </Toolbar>
              <Divider sx={{ margin: 0 }} />
              <Box sx={{ flex: 1, overflowY: "auto", minHeight: 0 }}>
                <Admindashboardinterviews />
              </Box>
            </Paper>
          </Grid>

          {/* Status */}
          <Grid item xs={12} md={2.2} sx={{ height: "100%" }}>
            <Paper elevation={2} sx={{ height: "100%", display: "flex", flexDirection: "column", borderRadius: "8px", overflow: "hidden" }}>
              <Toolbar
                sx={{
                  minHeight: "42px !important",
                  pl: { sm: 2 },
                  pr: { xs: 1, sm: 1 },
                }}
              >
                <Typography>Status</Typography>
              </Toolbar>
              <Divider sx={{ margin: 0 }} />
              <Box sx={{ flex: 1, overflowY: "auto", minHeight: 0 }}>
                <Adminselected />
              </Box>
            </Paper>
          </Grid>

        </Grid>
          </>
        )}
      </Box>
      {/* )} */}
      <Dialog
        open={view === "job"}
        onClose={() => setView("default")}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          sx={{
            bgcolor: "#f5f7fa",
            borderBottom: "1px solid rgba(0,0,0,0.08)",
            fontWeight: 700,
            fontSize: 16,
          }}
        >
          Job View
        </DialogTitle>

        <DialogContent sx={{ p: { xs: 2, sm: 3 } }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <Paper
                elevation={0}
                sx={{
                  p: { xs: 1.5, sm: 2 },
                  bgcolor: "#ffffff",
                  borderRadius: 1,
                  border: "1px solid rgba(0,0,0,0.04)",
                  display: "flex",
                  flexDirection: "column",
                  height: { xs: "60vh", sm: "56vh" }, // overall card height — adjust if you want
                }}
              >
                {/* --- Header: stays fixed (not inside scrollable area) --- */}
                <Box sx={{ mb: 1 }}>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 700, color: "#1a73e8", lineHeight: 1.2 }}
                  >
                    {jobDetails?.jobtitle || "—"}
                  </Typography>

                  <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" sx={{ mt: 1 }}>
                    <Chip
                      label={jobDetails?.company_name || "Company N/A"}
                      size="small"
                      sx={{ bgcolor: "transparent", border: "1px solid rgba(0,0,0,0.06)" }}
                    />
                    {jobDetails?.location && <Typography variant="body2" sx={{ color: "#5f6368", ml: 0.5 }}>
                      • {jobDetails?.location}
                    </Typography>}
                    {jobDetails?.experience && jobDetails.experience !== "null" && <Typography variant="body2" sx={{ color: "#5f6368", ml: 1 }}>
                      • {jobDetails?.experience}
                    </Typography>}
                  </Stack>
                </Box>

                <Divider sx={{ my: 1 }} />

                {/* --- Scrollable description area only --- */}
                <Box
                  sx={{
                    overflow: "auto",
                    // take remaining space inside Paper; prevents header from scrolling
                    flex: 1,
                    // optional: padding inside scroll area
                    p: { xs: 0.5, sm: 1 },
                    // improve scrollbar appearance on desktop
                    "&::-webkit-scrollbar": { width: 8 },
                    "&::-webkit-scrollbar-thumb": { bgcolor: "rgba(0,0,0,0.12)", borderRadius: 2 },
                  }}
                >
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                    Job Description
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{ color: "#333", whiteSpace: "pre-wrap", lineHeight: 1.6 }}
                  >
                    {htmlToPlainText(jobDetails?.job_description) || "No description available."}
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ p: 2, bgcolor: "#f5f7fa" }}>
          <Button onClick={() => setView("default")} variant="outlined" sx={{ textTransform: "none" }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openRecruiterDialog} onClose={handleRecruiterDialogClose}>
        <DialogTitle>Add Recruiter</DialogTitle>
        <Divider />
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                autoFocus
                margin="dense"
                label="Name"
                name="recruiter_name"
                fullWidth
                variant="outlined"
                value={recruiterFormData.recruiter_name}
                onChange={handleRecruiterChange}
                error={!recruiterFormData.recruiter_name && nameError} // Show error if the field is empty
                helperText={
                  !recruiterFormData.recruiter_name && nameError
                    ? "Name is required."
                    : ""
                }
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                margin="dense"
                label="Email"
                name="recruiter_email"
                fullWidth
                variant="outlined"
                value={recruiterFormData.recruiter_email}
                onChange={handleRecruiterChange}
                // onFocus={() => {
                //   console.log("Focus on");
                // }}
                onBlur={() => {
                  if (user?.username === recruiterFormData.recruiter_email) {
                    setEmailError("This email is already registered.");
                    handleSnackBar("This email is already registered.", "error");
                    return;
                  }
                }}
                error={!recruiterFormData.recruiter_email && emailError}
                helperText={
                  !recruiterFormData.recruiter_email && emailError
                    ? "Email is required."
                    : ""
                }
              />
            </Grid>
            <Grid item xs={6}>
              <InputMask
                mask="(999) 999-9999"
                value={recruiterFormData.recruiter_phone || ""}
                onChange={handleRecruiterChange}
              >
                {() => (
                  <TextField
                    margin="dense"
                    label="Mobile"
                    name="recruiter_phone"
                    fullWidth
                    variant="outlined"
                  />
                )}
              </InputMask>
            </Grid>
            <Grid item xs={6}>
              <TextField
                margin="dense"
                label="Role"
                name="recruiter_role"
                fullWidth
                variant="outlined"
                value={recruiterFormData.recruiter_role}
                onChange={handleRecruiterChange}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                type="url"
                margin="dense"
                label="Linkedin url"
                name="recruiter_linkedin"
                fullWidth
                variant="outlined"
                value={recruiterFormData.recruiter_linkedin}
                onChange={handleRecruiterChange}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                margin="dense"
                label="CompanyName"
                name="companyName"
                disabled
                fullWidth
                variant="outlined"
                value={user?.companyname || user?.company_name}
                onChange={handleRecruiterChange}
              // disabled
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleRecruiterDialogClose();
              if (myRecruiters.length === 0) {
                setNoRecruiterFound(true);
              }
            }}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleRecruiterSubmit}
            variant="contained"
            disabled={!user?.companyid || addRecruiterLoading ? true : false}
          >
            {addRecruiterLoading ? "Submitting" : "Submit"}
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Dialog
        open={!hasCompanyId}
        sx={{ "& .MuiDialog-paper": { width: "400px" } }}
        fullWidth
        maxWidth="xs"
      >
        <DialogContent
          sx={{
            p: 3,
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <BusinessOutlinedIcon sx={{ fontSize: 48, color: "#9e9e9e", mb: 1.5 }} />
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
            Company details required
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5 }}>
            Add your company details to view recruiters, candidates, submissions, and more.
          </Typography>
          <Box display="flex" justifyContent="center" gap={2}>
            <Button
              variant="contained"
              onClick={handleGoToCompanySettings}
              sx={{ textTransform: "none", backgroundColor: "#406882", boxShadow: "none" }}
            >
              Add Company
            </Button>
            <Button
              onClick={handleCloseCompanyDialog}
              color="primary"
              variant="outlined"
              sx={{ textTransform: "none" }}
            >
              Close
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        open={noRecruiterFound}
        fullWidth
        maxWidth="xs"
        sx={{ "& .MuiDialog-paper": { width: "400px" } }}
      >
        <DialogContent sx={{ textAlign: "center", padding: "15px" }}>
          <img
            src={Nocandidatefound}
            alt="Placeholder"
            style={{
              width: "100%",
              height: "auto",
              objectFit: "cover",
              borderRadius: "8px",
              marginBottom: "16px",
            }}
          />
          <Typography variant="body1">
            No Recruiter data was found based on the current search criteria.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            onClick={() => {
              handleAddRecruiter();
              setNoRecruiterFound(false);
            }}
            color="primary"
            variant="contained"
          >
            Add Recruiter
          </Button>
          <Button
            onClick={handleCloseDialog}
            color="primary"
            variant="outlined"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Admin_Allocation;
